import React from 'react'

import "./fadeBox.css"
import { Box } from '@mui/material'

export const FadBox = (props) =>
    <div className="fade-image-container">
        <Box position="relative">
            <Box
                component={"img"}
                srcSet={`${props.src}?fit=crop&auto=format&dpr=2 2x`}
                src={`${props.src}?fit=crop&auto=format`}
                alt={props.alt}
                className="fade-image"
                loading="lazy"
                zIndex={1}
                sx={{
                    borderRadius: 5,
                    cursor: "pointer",
                    boxShadow: "0px 0px 7px 0px #FAFAFA",
                }}
            />
            {props.text
                ? <div className="middle">
                    <p className="fade-text">{props.text}</p>
                </div>
                : null
            }
            <Box
                position="absolute"
                zIndex={2}
                width={'100%'}
                height={'100%'}
                top={0}
                left={0} />
        </Box>
    </div>
